import { sectionTitle, localize, storeSwitch } from "./dom";
import { KEY_HELP } from "./keyboard";
import type { Store } from "./store";

function link(text: string, href: string): HTMLAnchorElement {
  const a = document.createElement("a");
  a.href = href;
  a.textContent = text;
  a.target = "_blank";
  a.rel = "noopener";
  return a;
}

/** Splits a template at its `{key}` placeholders and puts the given nodes there. */
function fillNodes(template: string, nodes: Record<string, Node>): (string | Node)[] {
  return template
    .split(/\{(\w+)\}/)
    .map((part, k) => (k % 2 === 1 ? (nodes[part] ?? `{${part}}`) : part))
    .filter((part) => part !== "");
}

/** Fills the Help tab: shortcuts from KEY_HELP, the stats switch and the credits. */
export function mountHelp(panel: HTMLElement, store: Store): void {
  const keys = document.createElement("dl");
  keys.className = "help-keys";
  const credits = document.createElement("p");
  credits.className = "help-credits";
  const scope = link("Solar System Scope", "https://www.solarsystemscope.com/textures/");
  const license = link("CC BY 4.0", "https://creativecommons.org/licenses/by/4.0/");

  localize(store, (m) => {
    keys.replaceChildren(
      ...KEY_HELP.flatMap(({ display, label }) => {
        const dt = document.createElement("dt");
        const kbd = document.createElement("kbd");
        kbd.textContent = m.help.keyNames[display] ?? display;
        dt.append(kbd);
        const dd = document.createElement("dd");
        dd.textContent = m.help.keys[label];
        return [dt, dd];
      }),
    );
    credits.replaceChildren(...fillNodes(m.help.credits, { scope, license }));
  });

  panel.append(
    sectionTitle(store, (m) => m.help.keyboard),
    keys,
    sectionTitle(store, (m) => m.help.advanced),
    storeSwitch(
      (m) => m.help.stats,
      store,
      (s) => s.stats,
      (on) => ({ stats: on }),
    ),
    sectionTitle(store, (m) => m.help.about),
    credits,
  );
}
